module.exports = __webpack_public_path__ + "img/1986.9117ca36.png";